import React, { useEffect, useState } from 'react';
import { RegisterMFA } from '@milkmoovement/common_cognito_package';
import { useHistory } from 'react-router-dom';
import { onCognitoLogin } from '../../../auth/store/actions';
import { useDispatch } from 'react-redux';
import { getRegion } from '../../../../utils';
import { cacheAuthenticatedRegion, fetchAuthConfigFromBackend } from '../../../../utils/regionConfig';

const RegisterMFAPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [region, setRegion] = useState(sessionStorage.getItem('mm.auth.region'));
    const [coreSystem, setCoreSystem] = useState(sessionStorage.getItem('mm.auth.coreSystem'));
    const [isLoadingRegion, setIsLoadingRegion] = useState(true);

    // Fetch region from backend on component mount
    useEffect(() => {
        const loadRegion = async () => {
            try {
                const authMetadata = await fetchAuthConfigFromBackend();
                setRegion(authMetadata.region);
                setCoreSystem(authMetadata.coreSystem);
            } catch (error) {
                const fallbackRegion = getRegion(window.location.hostname);
                setRegion(fallbackRegion);
                setCoreSystem(fallbackRegion);
            } finally {
                setIsLoadingRegion(false);
            }
        };
        loadRegion();
    }, []);

    const handleNavigateBack = () => history.push({ pathname: '/login' });
    const handleSucessfulLogin = async () => {
        cacheAuthenticatedRegion(region);
        dispatch(await onCognitoLogin());
    };

    // Show loading state while fetching region
    if (isLoadingRegion || !region || !coreSystem) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <RegisterMFA
            onSucessfulLogin={handleSucessfulLogin}
            onNavigateBack={handleNavigateBack}
            metadata={{
                coreSystem,
            }}
        />
    );
};

export default RegisterMFAPage;
